export { PatientNextOfKinTab } from './PatientNextOfKinTab';
export { PatientDevicesTab } from './PatientDevicesTab';
export { PatientProfileTab } from './PatientProfileTab';
export { PatientMedicalAidTab } from './PatientMedicalAidTab';
export { PatientMedicalAidUpdateTab } from './PatientMedicalAidUpdateTab';
